export default "__VITE_ASSET__52ab0a1d__"